module.exports = __webpack_public_path__ + "media/images/arr_y-2b5af5e2c02e3c937ebdc5a9dae764e0.svg";